import { cn } from '@/lib/utils';
import { Sparkles, Zap, Star } from 'lucide-react';

interface TierBadgeProps {
  tier: 'free' | 'starter' | 'pro';
  className?: string;
}

export function TierBadge({ tier, className }: TierBadgeProps) {
  const Icon = tier === 'pro' ? Zap : tier === 'starter' ? Star : Sparkles;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold',
        tier === 'pro'
          ? 'bg-gradient-to-r from-indigo-500 to-purple-500 text-white'
          : tier === 'starter'
            ? 'bg-gradient-to-r from-emerald-500 to-teal-500 text-white'
            : 'bg-slate-100 text-slate-700',
        className
      )}
    >
      <Icon size={12} />
      {tier === 'pro' ? 'Pro' : tier === 'starter' ? 'Starter' : 'Free'}
    </span>
  );
}
